import script from "./ThirdPartyPhoneAccountConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThirdPartyPhoneAccountConfig.vue?vue&type=script&setup=true&lang=ts"

import "./ThirdPartyPhoneAccountConfig.vue?vue&type=style&index=0&id=b0a95c24&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0a95c24"]])

export default __exports__